import { string, bool, func, shape, object } from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import './NavListRow.scss';

const propTypes = {
  className: string,
  isSelected: bool,
  onClick: func
};

const NavListRow = props => {
  const className = classnames({
    ['nav-list-row']: true,
    ['nav-list-row--selected']: props.isSelected,
    [props.className]: props.className
  });

  return (
    <div className={className} onClick={props.onClick}>
      {props.children}
    </div>
  );
};

NavListRow.propTypes = propTypes;
export default NavListRow;
